import 'css-chunk:src/feature/check/CheckActivityTab.module.scss';export default {
  "root": "CheckActivityTab_root"
};